import type { JSX } from "react";
import { cn } from "./cn";
import { Checkbox } from "./Checkbox";

export interface SubtaskItemProps {
  /** Subtask title */
  readonly title: string;
  /** Metadata (due date, assignee) */
  readonly meta?: string;
  /** Whether the subtask is completed */
  readonly done?: boolean;
  /** Extra className */
  readonly className?: string;
}

/**
 * A subtask row with checkbox, title, and optional meta.
 */
export function SubtaskItem({ title, meta, done, className }: SubtaskItemProps): JSX.Element {
  return (
    <div className={cn("flex items-start gap-2 py-1.5", done && "opacity-50", className)}>
      <Checkbox checked={done} className="mt-0.5" />
      <div>
        <div className={cn("text-sm", done ? "line-through text-content-tertiary" : "text-content")}>
          {title}
        </div>
        {meta ? <div className="text-[10px] text-content-tertiary">{meta}</div> : null}
      </div>
    </div>
  );
}
